// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"fixtureContent_parentContainer__NtXMF","childContainer":"fixtureContent_childContainer__3SpFj"};